import { SVGInterface } from "../../interface";

const Unlink = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20.2916 21.707L11.5856 13H6.99961V11H9.58561L7.58561 8.99997H6.99961C5.34275 8.99997 3.99961 10.3431 3.99961 12C3.99961 13.6568 5.34275 15 6.99961 15H9.99961V17H6.99961C4.48116 17.002 2.35425 15.1307 2.03566 12.6325C1.71707 10.1343 3.30625 7.78902 5.74461 7.15897L2.29161 3.70697L3.70661 2.29297L21.7066 20.293L20.2926 21.706L20.2916 21.707ZM20.1356 15.893L18.7076 14.466C19.7861 13.7188 20.2539 12.3575 19.8626 11.1052C19.4713 9.85291 18.3116 9.00017 16.9996 8.99997H13.9996V6.99997H16.9996C19.1196 7.00022 21.009 8.33741 21.7142 10.3367C22.4195 12.3359 21.7872 14.5626 20.1366 15.893H20.1356Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Unlink;
